import { Injectable, NgZone } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { Patient } from '../components/order-entry/patient';
import { FormGroup } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class TimerService {

    constructor(private http: HttpClient, private zone: NgZone) {

    }

    private timeOut;
    private showing: boolean;

    public initListener(): void {
        console.log("timer started")
        this.timeOut = setTimeout(() => this.endTimer(), 10000);
        this.showing = false;

        this.zone.runOutsideAngular(() => {
            window.document.addEventListener('click', this.handleUserActiveState.bind(this));
        });
    }

    handleUserActiveState(event): void {
        console.log("reset timer")
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => this.endTimer(), 10000)
    }

    private subject = new Subject<any>();

    endTimer() {
        this.zone.run(()=>{
           console.log("time passed")
            this.stopListener();
            if(!this.showing){
                this.showing = true;
                this.subject.next();
            }
            else{
                console.log("showing dialog")
            } 
        })
        
    }

    getTimer(): Observable<any> {
        return this.subject.asObservable();
    }

    stopListener() {
        console.log("clear timer")
        clearTimeout(this.timeOut);
        this.zone.runOutsideAngular(() => {
            window.document.removeEventListener('click', this.handleUserActiveState.bind(this));
        });

    }
}
